import React from "react";
import { motion } from "framer-motion";

const WhatsAppButton = () => {
  const phoneNumber = "51968039152"; 
  const message = "¡Hola! Quiero más información sobre Mi DXN por favor.";

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.8, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1, duration: 0.5 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      className="fixed bottom-6 right-6 bg-[#25D366] hover:bg-[#20bd5a] text-white p-4 rounded-full shadow-lg shadow-green-500/30 z-50 cursor-pointer flex items-center justify-center transition-colors duration-300"
      aria-label="Contactar por WhatsApp"
    >
      {/* Ícono oficial de WhatsApp en SVG */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="w-7 h-7 fill-white"
      >
        <path d="M16 .5C7.44.5.5 7.44.5 16c0 2.8.73 5.53 2.11 7.92L.5 31.5l7.8-2.05A15.42 15.42 0 0 0 16 31.5c8.56 0 15.5-6.94 15.5-15.5S24.56.5 16 .5zm0 28.2c-2.56 0-5.07-.67-7.27-1.95l-.52-.31-4.63 1.22 1.24-4.5-.34-.55A12.97 12.97 0 0 1 3 16C3 8.82 8.82 3 16 3s13 5.82 13 13-5.82 12.7-13 12.7zm7.22-9.6c-.4-.2-2.35-1.16-2.71-1.29-.36-.14-.63-.2-.9.2-.27.4-1.04 1.28-1.27 1.55-.23.27-.47.3-.87.1-.4-.2-1.7-.63-3.24-2-1.2-1.07-2-2.4-2.23-2.8-.23-.4-.02-.62.18-.82.18-.18.4-.47.6-.7.2-.23.27-.4.4-.67.13-.27.07-.5-.03-.7-.1-.2-.9-2.15-1.24-2.95-.33-.8-.67-.7-.9-.7h-.77c-.27 0-.7.1-1.07.5-.37.4-1.4 1.37-1.4 3.34 0 1.97 1.44 3.87 1.64 4.14.2.27 2.84 4.34 6.87 6.1 4.04 1.76 4.04 1.17 4.77 1.1.73-.07 2.35-.96 2.68-1.9.33-.93.33-1.73.23-1.9-.1-.17-.36-.27-.76-.47z" />
      </svg>
    </motion.a>
  );
};

export default WhatsAppButton;